export default {
  styleOverrides: {  root: {
        marginTop:"0px",
        marginBottom:"0px",
        textAlign:"left "
      }
    }
}